import React from 'react';
import PropTypes from 'prop-types';
import { HashLink as Link } from 'react-router-hash-link';
import { I18nUtils } from '../../../i18n/I18nUtils';

export class OutsourceBanner extends React.Component {

    render() {
        if ( !this.props.outsource || !!this.props.outsource.ccc ) return null;

        return (
            <div className="alert alert-light">
                <strong>Aviso:</strong> El campo <i>Código Cuenta Cotización (C.C.C.)</i> no se ha completado.
                <Link to={'#outsource-form-card'}>{I18nUtils.tr('TR_VER_FICHA')}</Link>
            </div>
        );
    }
}

OutsourceBanner.propTypes = {
    outsource: PropTypes.any,
};

OutsourceBanner.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/dashboard/banner/OutsourceBanner.jsx